// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__yUpG3","error":"Textarea_error__udcAi","readonly":"Textarea_readonly__aq3t8","disabled":"Textarea_disabled__2xIvF"};